import React from 'react';
import { Modal as SkunexusModal } from '@skunexus/component-catalog';

function RepushProductModal(props) {
    const {
        isOpen = false,
        isLoading = false,
        headerLabel = 'Confirm Product to repush',
        onClose = () => {},
        onConfirm = () => {},
    } = props;

    return (
        <SkunexusModal
            isOpen={isOpen}
            isLoading={isLoading}
            headerLabel={headerLabel}
            cancelOnClick={onClose}
            confirmOnClick={onConfirm}
        >
            <p>Are you sure you want to repush the product?</p>
        </SkunexusModal>
    );
}

export default RepushProductModal;
